<div
  fxLayout="column"
  fxFlexAlign="space-around flex-start"
  class="confirmation-wrapper p-40"
>
  <div class="text-wrapper mb-50">
    <div class="title text-yellow font-22 bold font-chakra">
      {{ data?.title | translate }}
    </div>
    <div class="message text-gray font-15 mt-15">
      {{ data?.message | translate }}
    </div>
  </div>
  <div
    fxLayout="row"
    fxLayoutAlign="center center"
    class="actions-wrapper w-full"
  >
    <button
      [mat-dialog-close]="true"
      class="aum-button px-50 w-300"
      color="primary"
      mat-raised-button
    >
      {{ 'general.ok' | translate | uppercase }}
    </button>
  </div>
</div>
